import Vue from 'vue';
import Vuex from 'vuex';

import products from './products';
import kids from './kids';
import missions from './missions';
import wishes from './wishes';
import payments from './payments';
import gifts from './gifts';
import blog from './blog';

import SessionUser from '../helpers/session-user';
import Formatter from '../helpers/formatter';
import _ from 'lodash';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      name: SessionUser._getUserInfo().name || '',
      email: SessionUser._getUserInfo().email || '',
      phone: SessionUser._getUserInfo().phone || '',
      points: SessionUser._getUserInfo().points || 0,
      role: SessionUser._getUserInfo().role || '',
      avatar: SessionUser._getUserInfo().avatar || '',
      token: SessionUser._getUserInfo().token || '',
      lastLogin: SessionUser._getUserInfo().lastLogin || ''
    },
    error: { message: null, type: null },
    ui: { showNewKid: false },
    isLoading: false
  },

  mutations: {
    resetAllState(state, payload = []) {
      if (payload instanceof Array === false) {
        return;
      }

      const initState = SessionUser._getInitialStateInfo();
      const _initState = payload.length
        ? _.omit(initState, payload)
        : initState;

      _.extend(state, _initState);
    },

    setError(state, error) {
      state.error = error;
    },

    dismissError(state) {
      state.error = { message: null, type: null };
    },

    toggleNewKidForm(state) {
      state.ui.showNewKid = !state.ui.showNewKid;
    },

    setUserInfo(state, payload) {
      state.user = Formatter.extend(state.user, payload);
    },

    logout(state) {
      state.user = {};
    },

    setLoadingStatus(state, isLoading) {
      state.isLoading = isLoading;
    }
  },

  getters: {
    isLoggedIn: state => !!state.user.token,
    userInfo: state => state.user,
    loadingStatus: state => state.isLoading
  },

  modules: {
    products: products,
    kids: kids,
    missions: missions,
    wishes: wishes,
    payments: payments,
    gifts: gifts,
    blog: blog
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js